"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const CheckboxSetting = ({ name = '', label = '', onChange = () => ({}), isChecked = false, disabled = false, dataTestId = '', } = {}) => {
    return ((0, jsx_runtime_1.jsx)(material_1.FormControl, { sx: { pt: 1 }, children: (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { labelPlacement: "start", control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { "data-testid": dataTestId, name: name, checked: isChecked, disabled: disabled, onChange: event => onChange(event.target.name, event.target.checked) }), label: label }) }));
};
exports.default = CheckboxSetting;
